import { useCallback } from "react";
import { useUserApi } from "@/hooks/apiHooks/useUserApi";
import { isCustomerWalled } from "@models/user";

/**
 * #368: what a customer write does with a 403. Every 403 body is the API's one
 * generic sentence, so the reason is learned by reading /users/me again.
 * getMeUser publishes the answer to currentUserAtom, and ApprovalGate then
 * moves a walled customer to the wall that says why.
 *
 * Resolves true when the fresh /users/me puts the customer behind a wall
 * (isCustomerWalled), false when it does not. A failed re-read is false too: it
 * moved nobody, so the caller still has to say that its write failed. useApi
 * toasts a failed re-read unless the session ended while it was out; and if
 * the session ended, getMeUser publishes nothing, so even a walled answer moves
 * nobody. Both happen only as the signed-out app is going away.
 */
export const useWallReRead = (): (() => Promise<boolean>) => {
    const { getMeUser } = useUserApi();

    return useCallback(async () => {
        try {
            return isCustomerWalled(await getMeUser());
        } catch {
            return false;
        }
    }, [getMeUser]);
};
